import { Avatar, Box, Flex, Icon, Loading, Text } from 'ui'

import { usePulseContext } from '../../context/PulseProvider'
import { useTopWorkers } from 'queries/pulse/useTopWorkers'
import { formatNumber } from 'lib/string'
import { StarIcon } from 'lucide-react'

export function TopWorkers() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data: topWorkers, isLoading } = useTopWorkers(filters)

  if (!isLoading && !topWorkers?.length) {
    return null
  }

  return (
    <Box flex={1}>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        mb={0}
      >
        <Text fontSize={3} fontWeight="500">
          Top Workers
        </Text>
      </Flex>
      <Text fontSize={2} color="lightText" mb={3} mt={0}>
        Top workers based on shift count.
      </Text>
      {isLoading ? (
        <Box p={3}>
          <Loading />
        </Box>
      ) : (
        <Flex flexDirection="row" gap={3}>
          {topWorkers?.slice(0, 6)?.map((worker) => (
            <Box
              key={worker.worker_id}
              border="1px solid"
              borderColor="neutrals.100"
              borderRadius="large"
              p={3}
              flex={1}
            >
              <Flex
                flexDirection="column"
                gap={2}
                justifyContent="space-between"
                height="100%"
              >
                <Flex flexDirection="row" gap={2}>
                  <Flex flexDirection="column" flex={1}>
                    <Text fontWeight="500">{worker.worker_name}</Text>
                    <Text color="lightText" fontSize="1" fontWeight="500">
                      {worker.worker_most_recent_position_name}
                    </Text>
                  </Flex>
                  <Avatar
                    size={'medium'}
                    user={{
                      userId: worker.worker_id.toString(),
                      name: worker.worker_name,
                      photoUrl: worker.worker_profile_pic_url ?? undefined,
                    }}
                  />
                </Flex>
                <Flex
                  flexDirection="row"
                  gap={2}
                  justifyContent="space-between"
                >
                  <Flex flexDirection="column">
                    <Text color="lightText" fontSize="1" fontWeight="500">
                      Rating
                    </Text>
                    <Text fontSize="5" fontWeight="500">
                      <Icon icon={StarIcon} size={16} />{' '}
                      {worker.worker_rating.toFixed(1)}
                    </Text>
                  </Flex>
                  <Flex flexDirection="column">
                    <Text color="lightText" fontSize="1" fontWeight="500">
                      Shifts
                    </Text>
                    <Text fontSize="5" fontWeight="500">
                      {formatNumber(worker.shift_count)}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          ))}
        </Flex>
      )}
    </Box>
  )
}
